module.exports = __webpack_public_path__ + "static/media/corner-4.e9bba510.png";